import { setupNextraPage } from 'nextra/setup-page'

/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
export const __toc = [{
  depth: 2,
  value: "Présentation",
  id: "présentation"
}, {
  depth: 3,
  value: "Philosophie",
  id: "philosophie"
}, {
  depth: 2,
  value: "Pourquoi utiliser le CSS ?",
  id: "pourquoi-utiliser-le-css-"
}, {
  depth: 2,
  value: "Avantages du CSS",
  id: "avantages-du-css"
}, {
  depth: 3,
  value: "Exemples en CSS",
  id: "exemples-en-css"
}, {
  depth: 4,
  value: "Exemple de style de texte",
  id: "exemple-de-style-de-texte"
}, {
  depth: 4,
  value: "Exemple de mise en page responsive",
  id: "exemple-de-mise-en-page-responsive"
}, {
  depth: 2,
  value: "Conclusion",
  id: "conclusion"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    p: "p",
    strong: "strong",
    em: "em",
    h3: "h3",
    ol: "ol",
    li: "li",
    ul: "ul",
    h4: "h4",
    pre: "pre",
    code: "code",
    span: "span"
  }, _provideComponents(), props.components);
  return <><_components.h1>{"Qu'est-ce que le CSS ?"}</_components.h1>{"\n"}<_components.h2 id="présentation">{"Présentation"}</_components.h2>{"\n"}<_components.p>{"Le "}<_components.strong>{"CSS"}</_components.strong>{", ou "}<_components.em>{"Cascading Style Sheets"}</_components.em>{", est un langage de style utilisé pour définir la présentation des documents HTML et XML sur le web. Apparu pour la première fois en 1996, le CSS permet aux développeurs web de séparer la structure du contenu (HTML) de son apparence visuelle, facilitant ainsi la gestion et la personnalisation des styles."}</_components.p>{"\n"}<_components.h3 id="philosophie">{"Philosophie"}</_components.h3>{"\n"}<_components.p>{"La philosophie fondamentale du CSS repose sur la séparation des préoccupations, visant à isoler le style du contenu. En adoptant cette approche, le CSS offre une modularité accrue, permettant des mises à jour et des modifications de style sans altérer la structure sous-jacente du document. Cela favorise une maintenance plus aisée et une meilleure évolutivité des projets web."}</_components.p>{"\n"}<_components.h2 id="pourquoi-utiliser-le-css-">{"Pourquoi utiliser le CSS ?"}</_components.h2>{"\n"}<_components.p>{"L'utilisation du CSS est essentielle pour plusieurs raisons fondamentales :"}</_components.p>{"\n"}<_components.ol>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Consistance de la présentation :"}</_components.strong>{" En centralisant les règles de style dans une feuille de style externe, le CSS assure une cohérence visuelle sur l'ensemble du site web."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Facilité de maintenance :"}</_components.strong>{" La séparation du contenu et du style facilite la maintenance du code. Les modifications de style peuvent être apportées rapidement sans altérer la structure HTML."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Adaptabilité aux différents dispositifs :"}</_components.strong>{" Le CSS permet de créer des mises en page réactives et adaptatives grâce aux médias queries, garantissant une expérience utilisateur optimale sur une variété de dispositifs, des smartphones aux écrans de bureau."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Optimisation du référencement :"}</_components.strong>{" L'utilisation judicieuse du CSS peut améliorer le référencement en rendant le contenu plus accessible pour les moteurs de recherche tout en maintenant une expérience utilisateur attrayante."}</_components.p>{"\n"}</_components.li>{"\n"}</_components.ol>{"\n"}<_components.h2 id="avantages-du-css">{"Avantages du CSS"}</_components.h2>{"\n"}<_components.p>{"Les avantages de l'utilisation du CSS sont multiples et impactent directement la qualité et la maintenabilité des sites web :"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Simplicité de la syntaxe :"}</_components.strong>{" La syntaxe claire et simple du CSS le rend accessible aux développeurs, facilitant la création et la gestion de styles."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Réutilisabilité du code :"}</_components.strong>{" Les règles de style peuvent être réutilisées sur différentes pages du site, réduisant ainsi la redondance du code."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p><_components.strong>{"Contrôle fin sur la mise en page :"}</_components.strong>{" Les sélecteurs CSS offrent un contrôle précis sur la manière dont les éléments HTML sont présentés, permettant une mise en page détaillée et personnalisée."}</_components.p>{"\n"}</_components.li>{"\n"}</_components.ul>{"\n"}<_components.h3 id="exemples-en-css">{"Exemples en CSS"}</_components.h3>{"\n"}<_components.h4 id="exemple-de-style-de-texte">{"Exemple de style de texte"}</_components.h4>{"\n"}<_components.pre data-language="css" data-theme="default" hasCopyCode><_components.code data-language="css" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/* Commentaire : Style du texte */"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"body"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"font-family"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'Arial'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{" sans-serif"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"font-size"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"16"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"px"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"color"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"#333"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"line-height"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1.6"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"font-size"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"24"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"px"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"color"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"#0066cc"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h4 id="exemple-de-mise-en-page-responsive">{"Exemple de mise en page responsive"}</_components.h4>{"\n"}<_components.pre data-language="css" data-theme="default" hasCopyCode><_components.code data-language="css" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"/* Commentaire : Mise en page responsive */"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"@media"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"screen"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"and"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"max-width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"600"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"px"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"body"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"font-size"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"14"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"px"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"h1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"font-size"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"20"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"px"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.h2 id="conclusion">{"Conclusion"}</_components.h2>{"\n"}<_components.p>{"En conclusion, le CSS est un élément clé du développement web moderne, offrant une méthode structurée et efficace pour styliser les documents HTML. Son adoption permet une gestion simplifiée de la présentation, une maintenance aisée du code, et une adaptation fluide aux différents dispositifs. En intégrant judicieusement le CSS avec les autres technologies web, les développeurs peuvent créer des interfaces utilisateur attrayantes et fonctionnelles."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/cours/css/introduction.mdx","route":"/cours/css/introduction","timestamp":1706374742000,"title":"Qu'est-ce que le CSS ?",headings:__toc},
  pageNextRoute: "/cours/css/introduction",
  
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)